import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

/** Lee el orden de categorías definido en el módulo "Página Web". */
export function useOrdenCategorias() {
  const [orden, setOrden] = useState([]);
  useEffect(() => {
    getDoc(doc(db, 'config', 'pagina_web'))
      .then(d => { if (d.exists() && Array.isArray(d.data().ordenCategorias)) setOrden(d.data().ordenCategorias); })
      .catch(() => {});
  }, []);
  return orden;
}
